import script from "./TutorialBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialBoard.vue?vue&type=script&setup=true&lang=js"

import "./TutorialBoard.vue?vue&type=style&index=0&id=4564e303&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4564e303"]])

export default __exports__